import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FaFileUpload, FaHome, FaRedo, FaUpload } from 'react-icons/fa';
import './sidebar.css'
import { FaNoteSticky, FaUserPlus } from 'react-icons/fa6';

const Sidebar = () => {
  const isCollapsed = useSelector((state) => state.sidebar.value);
  const { user } = useSelector(state => state.admin);
  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <nav>
        <ul>

          {user === "ADMIN" &&
            <li>
              <Link to="/dashboard/home-admin">
                <FaHome size={24} className='icon' />
                {!isCollapsed && <span className='ms-3'>Admin Home</span>}
              </Link>
            </li>}
          {user === "ALC" && (
            <>
              <li>
                <Link to="/dashboard/home">
                  <FaHome size={24} className='icon' />
                  {!isCollapsed && <span className='ms-3'>Home</span>}
                </Link>
              </li>

              <li>
                <Link to="/dashboard/register-user">
                  <FaUserPlus size={24} className='icon' /> 
                  {!isCollapsed && <span className='ms-3'>Register Student</span>}
                </Link>
              </li>

              <li>
                <Link to="/dashboard/bulk-register">
                  <FaFileUpload size={24} className='icon' /> 
                  {!isCollapsed && <span className='ms-3'>Bulk Upload</span>}
                </Link>
              </li>

              <li>
                <Link to="/dashboard/bulk-renew">
                  <FaRedo size={24} className='icon' />
                  {!isCollapsed && <span className='ms-3'>Renew Plan</span>}
                </Link>
              </li>

            </>)}

        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar
